module.exports = __webpack_public_path__ + "img/17.04db4dea.png";